import React, { useState } from "react";
import ContactImg from "../../Images/contactus/contact-us-banner.webp";
import Enquiry from "./Enquiry";
import Feedback from "./Feedback";
import CallToAction from "./CallToAction";
import FeedbackSuccess from "./FeedbackSuccess";

const ContactUs = () => {
  const [formToggle, setFormToggle] = useState("enquiry");

  return (
    <div className="bg-bgBlack p-0 sm:p-3 relative min-h-screen flex flex-col gap-4">
      {/* <div className="relative">
        <img src={ContactImg} alt="ContactUsImg" className="" />
        <div className="absolute inset-0 flex top-36 gap-4  bg-opacity-10 mx-8 flex-col">
          <h2 className="text-white text-5xl font-bold">
            Get in Touch with Us
          </h2>
          <h3 className="text-white text-2xl font-bold">
            Seamless Support , Anytime You Need!
          </h3>
        </div>
      </div> */}

      <div className=" text-white md:w-[60%] flex justify-center gap-5 my-4  flex-col items-center mx-auto ">
        <h1 className="md:text-3xl text-xl font-bold bg-error p-2 rounded  mx-auto">
          Click, Connect, Power Up
        </h1>
        <p className="text-center">
          We’re here to assist you every step of the way. Whether you have a
          question, need support, or just want to connect, we’ve made reaching
          out simple and hassle-free.
        </p>
      </div>
      <div className="flex sm:flex-row flex-col-reverse rounded justify-around md:w-[90%] w-full md:gap-10 gap-5 mx-auto mb-10 ">
        <div className="bg-lightBlack text-white p-2 sm:p-6 w-full justify-center  flex flex-col rounded-md gap-4 border-none sm:border border-neutral shadow-md">
          <div className="w-full justify-center flex flex-row gap-4">
            {" "}
            <button
              className={`rounded shadow-md md:text-xl text-base md:py-3 py-2 md:px-6 px-4 font-semibold ${
                formToggle === "enquiry"
                  ? "bg-error text-white"
                  : "bg-white text-black"
              }`}
              onClick={() => {
                setFormToggle("enquiry");
              }}
            >
              Enquiry
            </button>
            <button
              className={`rounded md:text-xl text-base md:py-3 py-2 md:px-6 px-4 font-semibold shadow-md  ${
                formToggle === "feedback"
                  ? "bg-error text-white"
                  : "bg-white text-black"
              }`}
              onClick={() => {
                setFormToggle("feedback");
              }}
            >
              Feedback
            </button>
          </div>
          {formToggle === "enquiry" && <Enquiry />}
          {formToggle === "feedback" && <Feedback />}
        </div>{" "}
        <div className="bg-lightBlack rounded-md text-white p-2 sm:p-6 w-full justify-center flex flex-col gap-4 border-none sm:border border-neutral shadow-md">
          <CallToAction />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
